
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZListItem',
  props: {
    as: {
      type: String,
      default: 'div'
    },
    icon: {
      type: String
    },
    iconSize: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      styles: {
        a: 'hover:text-juniper transition-all duration-300 ease-in-out'
      } as Record<string, string>
    }
  },
  computed: {
    tagSpecificStyles(): string {
      return this.styles[this.as] || ''
    }
  }
})
